/*******************************************************************************
 * File: Header.js
 * Summary: Demo website header (across all pages)
 ******************************************************************************/

/*******************************************************************************
 * Section: Imports
 ******************************************************************************/
import { useRef } from 'react'
import styled from 'styled-components'

import { Form, FormContainer } from '../styled/CommonStylesForms'

/*******************************************************************************
 * Section: Custom Divs
 ******************************************************************************/

const AccountRow = styled.div`
  margin: 0 auto;
  padding: 0 13px;
  max-width: 570px;
  overflow: hidden;
`

const BannerHeader = styled.h1`
  color: #ffffff;
  font-weight: 300;
  font-size: 53px;
  line-height: 60px;
  letter-spacing: -5%;
  text-align: center;
  vertical-align: middle;
  margin-top: 30px;
  margin-bottom: 10px;
`

const BannerText = styled.p`
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
`

const BannerButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const BannerButton = styled.button`
  // Figma
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;

  // Custom
  background-color: transparent;
  color: #ffffff;
  padding: 0px 30px;
  border: solid;
  border-width: 1px;
  border-radius: 14px;
  height: 27px;
  :hover {
    cursor: pointer;
  }
`
const HeaderVerify = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;

  text-align: center;
  margin: 7px;
`
const HeaderText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;

  text-align: center;
`
const PromotionText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;

  color: black;
  text-align: left;
  margin: 0 5px;
  padding: 5px;
`
const BottomSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ModalLabel = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #4c3de3;
  height: 21px;
`

const InputFieldModal = styled.input`
  font-size: 16px;
  width: 100%;
  padding: 4px;
  border: 1px solid #d3d2c9;
  border-radius: 15px;

  float: left;
  width: 100%;
  height: 39px;
`

const BtnPrimaryLarge = styled.button`
  padding: 0 40px;
  height: 44px;

  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  border: solid;
  border-width: 1px;
  border-radius: 22px;
  border-color: #4c3de3;
  background-color: #ffffff;
  color: #4c3de3;

  :hover {
    cursor: pointer;
  }
`

const InputBox = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  height: 60px;
`

/*******************************************************************************
 * Function: LoggedInAccountHeader:
 * Summary: Account portion of the Header. Displays an icon along with the users
 *          name beside the users icon
 ******************************************************************************/
function CreateAccountPage(props) {
  const newForm = useRef()

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = new FormData(newForm.current)
    props.setUserData({
      username: form.get('username'),
      given_names: form.get('given_names'),
      family_names: form.get('family_names'),
      phone_number: form.get('phone_number'),
      email: form.get('email'),
      password: form.get('password'),
      confirm_password: form.get('confirm_password'),
    })
    props.setPageState('create-account-issue')
    props.setLoader(false)
  }

  return (
    <AccountRow>
      <BannerHeader>CREATE  &nbsp;AN  &nbsp;ACCOUNT</BannerHeader>
      <BannerText>
        Begin your journey by creating a free SITA Air account and enjoy <br></br>
        trip tracking, quicker check-in, bonus miles and more.
      </BannerText>
      <BannerButtonWrapper>
        <BannerButton>
          Already have an account?{' '}
          <u>Log in</u>
        </BannerButton>
      </BannerButtonWrapper>
      <div>
        <FormContainer>
          <HeaderVerify>Tell us about yourself</HeaderVerify>
          <HeaderText>
            All fields are required unless otherwise noted
          </HeaderText>
          <Form id="form" onSubmit={handleSubmit} ref={newForm}>
            <InputBox>
              <ModalLabel>Username</ModalLabel>
              <InputFieldModal
                type="text"
                name="username"
                defaultValue={props.userData.username}
              ></InputFieldModal>
            </InputBox>
            <InputBox>
              <ModalLabel>Given name(s)</ModalLabel>
              <InputFieldModal
                type="text"
                name="given_names"
                defaultValue={props.userData.given_names}
              ></InputFieldModal>
            </InputBox>
            <InputBox>
              <ModalLabel>Family name(s)</ModalLabel>
              <InputFieldModal
                type="text"
                name="family_names"
                defaultValue={props.userData.family_names}
              ></InputFieldModal>
            </InputBox>
            <InputBox>
              <ModalLabel>Phone number</ModalLabel>
              <InputFieldModal
                type="text"
                name="phone_number"
                defaultValue={props.userData.phone_number}
              ></InputFieldModal>
            </InputBox>
            <InputBox>
              <ModalLabel>Email address</ModalLabel>
              <InputFieldModal
                type="text"
                name="email"
                defaultValue={props.userData.email}
              ></InputFieldModal>
            </InputBox>
            <InputBox>
              <ModalLabel>Password</ModalLabel>
              <InputFieldModal
                type="password"
                name="password"
              ></InputFieldModal>
            </InputBox>
            <InputBox>
              <ModalLabel>Confirm Password</ModalLabel>
              <InputFieldModal
                type="password"
                name="confirm_password"
                defaultValue={props.userData.confirm_password}
              ></InputFieldModal>
            </InputBox>
            <BottomSection>
              <input type="checkbox" />
              <PromotionText>
                I would like to receive promotional emails and newsletters from
                SITA Air.
              </PromotionText>
              <BtnPrimaryLarge type="submit">Continue</BtnPrimaryLarge>
            </BottomSection>
          </Form>
        </FormContainer>
      </div>
    </AccountRow>
  )
}

export default CreateAccountPage
